
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CreditCard, ExternalLink, Loader2 } from "lucide-react";

interface UpgradePlansProps {
  processingUpgrade: boolean;
  handleUpgrade: (type: 'monthly' | 'yearly') => void;
  checkoutUrl: string | null;
}

export const UpgradePlans = ({ processingUpgrade, handleUpgrade, checkoutUrl }: UpgradePlansProps) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="space-y-4">
          <h3 className="font-medium">Upgrade Your Plan</h3>
          <p className="text-sm text-muted-foreground">
            Choose a subscription plan to get unlimited recipe transformations.
          </p>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="border rounded-lg p-4 space-y-3">
              <h4 className="font-medium">Monthly Plan</h4>
              <p className="text-sm text-muted-foreground">$5/month - Unlimited transformations</p>
              <Button
                className="w-full"
                onClick={() => handleUpgrade('monthly')}
                disabled={processingUpgrade}
              >
                {processingUpgrade ? (
                  <>
                    <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                    Processing...
                  </>
                ) : (
                  <>
                    <CreditCard className="h-4 w-4 mr-2" />
                    Choose Monthly
                  </>
                )}
              </Button>
            </div>
            
            <div className="border rounded-lg p-4 space-y-3">
              <h4 className="font-medium">Yearly Plan</h4>
              <p className="text-sm text-muted-foreground">$50/year - Save $10!</p>
              <Button
                variant="outline"
                className="w-full"
                onClick={() => handleUpgrade('yearly')}
                disabled={processingUpgrade}
              >
                {processingUpgrade ? (
                  <>
                    <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                    Processing...
                  </>
                ) : (
                  <>
                    <CreditCard className="h-4 w-4 mr-2" />
                    Choose Yearly
                  </>
                )}
              </Button>
            </div>
          </div>
          
          {checkoutUrl && (
            <div className="mt-4 p-3 border border-yellow-300 bg-yellow-50 rounded-lg">
              <p className="text-sm text-yellow-800 mb-2">
                If the checkout page doesn't open automatically, please click the button below:
              </p>
              <Button 
                variant="outline" 
                className="w-full flex items-center justify-center gap-2"
                onClick={() => window.open(checkoutUrl, '_blank')}
              >
                Open Checkout <ExternalLink size={16} />
              </Button>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
